import { categoryFromAPI } from "../utils/categoryFromAPI"

const getAPI = async (url, msgErro) => {
    const resposta = await fetch(url)
    if (resposta.ok) {
        return resposta.json()
    }
    throw new Error(msgErro)
}

const postAPI = async (url, obj, msgErro) => {
    const resposta = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
    })

    if (resposta.ok) {
        return resposta.json()
    }

    throw new Error(msgErro)

}

const putAPI = async (url, obj, msgErro) => {
    const resposta = await fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(obj)
    })

    if (resposta.ok) {
        return resposta.json()
    }

    throw new Error(msgErro)

}

const baseURL = 'https://onprice-api.fly.dev'

// Requisições de Categorias
export const apiCategorias = {

    listaProdutos: (categoria) => getAPI(`${baseURL}/${categoryFromAPI[categoria]}`, 'Não foi possível listar os produtos.'),

    listaProdutosCompativeis: (categoria, obj) => postAPI(`${baseURL}/filter/compatibility/${categoria}`, obj, 'Não foi possível listar os produtos compativeis.'),

    listaNames: (categoria) => getAPI(`${baseURL}/${categoryFromAPI[categoria]}/names`, 'Não foi possível listar os nomes dos produtos.'),

    listaProdutoConfigs: (categoria, id) => getAPI(`${baseURL}/${categoryFromAPI[categoria]}/${id}`, 'Não foi possível listar as especificações do produto.'),

    listaFiltrosCategoria: (categoria) => getAPI(`${baseURL}/${categoryFromAPI[categoria]}/filter/values`, 'Não foi possível listar os filtros.'),

    listaFiltrosGenerico: () => getAPI(`${baseURL}/filter/values`, 'Não foi possível listar os filtros genéricos.'),

    filtrarCategoria: (categoria, filtros) => postAPI(`${baseURL}/${categoryFromAPI[categoria]}/filter`, filtros, 'Não foi possível aplicar os filtros por categoria.'),
}

// Pega produto pelo id
export const apiUrl = {
    listaConfigs: (id) => getAPI(`${baseURL}/search/id/${id}`, 'Não foi possível listar as especificações.')
}

// Pega produtos pela pesquisa
export const apiSearch = {
    pesquisaProdutos: (busca) => getAPI(`${baseURL}/search/${busca}`, 'Não foi possível listar os resultados da busca.'),
    pesquisaProdutosCompativeis: (busca, categoria, obj) => postAPI(`${baseURL}/search/compatibility/${categoria}/${busca}`, obj, 'Não foi possível listar os resultados da busca.')
}

// Requisições do Usuário
export const apiUser = {
    logaUsuario: (email) => postAPI(`${baseURL}/users/login`, { email }, 'Não foi possível logar o usuário com o a API.'),

    mostraTodosUsuarios: () => getAPI(`${baseURL}/users`, 'Não foi possível mostrar todos os usuários registrados.'),

    criaNotificacaoEmail: (email, price, category, product_id) => postAPI(`${baseURL}/notifications/${email}/False`, {price, category, product_id, type: 'email'}, 'Não foi possível criar a notificação de preço por email.'),

    criaNotificacaoNavegador: (token, price, category, product_id) => postAPI(`${baseURL}/notifications/False/${token}`, {price, category, product_id, type: 'push'}, 'Não foi possível criar a notificação de preço por navegador.'),

    salvaSetup: (email, setup) => postAPI(`${baseURL}/users/${email}/setups`, setup, 'Não foi possível salvar o setup do usuário.'),

    pegaSetups: (email) => getAPI(`${baseURL}/users/${email}/setups`, 'Não foi possível pegar os setups do usuário.'),
}